export const MATERIALS = [
  'No materials needed',
  'Common classroom materials',
  'Allow the use of any materials',
];